/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2019 Deere & Company

import './index.scss';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

const composeClasses = (className) => className ?
    `labeled-string ${className}` :
    'labeled-string';

const LabeledString = (props) => (
    <div className={composeClasses(props.className)}>
        <span className="data-label">
            {props.shouldTranslate ? (
                <FormattedMessage
                    id={props.label}
                    values={props.values}
                />
            ) :
                props.label
            }
        </span>
        <span className="data-key">{props.data}</span>
    </div>
);

LabeledString.displayName = 'LabeledString';
LabeledString.propTypes = {
    className: PropTypes.string,
    data: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    shouldTranslate: PropTypes.bool,
    values: PropTypes.object,
};

LabeledString.defaultProps = {
    shouldTranslate: true,
};

export default LabeledString;
